function setMaxVal(props, initialValue) {
  const height = Math.abs(props.maxScroll);
  return props.fromBottom ? parseInt((Math.abs(props.posTop * height) + height - (height * 0.25)) / 1.55) : parseInt((initialValue + height - (height * 0.25)) / 1.55)
}
export default setMaxVal;

